/**
 * Timezone conversion utilities for the frontend
 */

// Get user's timezone offset in minutes from UTC
// Positive for east of UTC (e.g., +180 for UTC+3)
// Negative for west of UTC (e.g., -300 for UTC-5)
export function getTimezoneOffsetMinutes(): number {
  const offsetMinutes = -new Date().getTimezoneOffset();
  return offsetMinutes;
}

// Get user's timezone name (e.g., "America/New_York")
export function getTimezoneName(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}

// Convert a UTC timestamp to local date/hour
export function utcTimestampToLocal(utcTimestamp: number): { date: string; hour: number } {
  const utcDate = new Date(utcTimestamp * 1000); // Convert Unix timestamp to milliseconds
  
  // Get local date and hour
  const year = utcDate.getFullYear();
  const month = String(utcDate.getMonth() + 1).padStart(2, '0');
  const day = String(utcDate.getDate()).padStart(2, '0');
  const hour = utcDate.getHours();
  
  return {
    date: `${year}-${month}-${day}`,
    hour,
  };
}

// Convert local date/hour to UTC timestamp
export function localToUtcTimestamp(localDate: string, localHour: number): number {
  // Parse the date (YYYY-MM-DD)
  const [year, month, day] = localDate.split('-').map(Number);
  
  // Create a date object in local timezone
  const localDateTime = new Date(year, month - 1, day, localHour, 0, 0, 0);
  
  // Get UTC timestamp (in seconds)
  return Math.floor(localDateTime.getTime() / 1000);
}

// Format timezone offset for display (e.g., "UTC+3" or "UTC-5")
export function formatTimezoneOffset(offsetMinutes: number): string {
  if (offsetMinutes === 0) return 'UTC';
  
  const absMinutes = Math.abs(offsetMinutes);
  const hours = absMinutes / 60;
  const sign = offsetMinutes > 0 ? '+' : '-';
  
  if (hours % 1 === 0) {
    // Whole hours (e.g., UTC+3, UTC-5)
    return `UTC${sign}${Math.floor(hours)}`;
  } else {
    // Half hours (e.g., UTC+5:30)
    const wholeHours = Math.floor(hours);
    const minutes = absMinutes % 60;
    return `UTC${sign}${wholeHours}:${String(minutes).padStart(2, '0')}`;
  }
}

